import React, { ReactNode, useEffect, useState } from "react";

import {
  Tab,
  Header,
  Table,
  Button,
  Dropdown,
  Modal,
  Input,
  Pagination,
  Icon,
  TextArea,
  Grid,
} from "semantic-ui-react";

import moment from "moment";

import DateTextBox from "../common/DateTextBox";

import "./CardOAMemberList.scss";

import { parseBeOrAdDate } from "react-lib/utils/dateUtils";

type CardOAMemberListProps = {
  buttonLoadCheck?: any;
  onEvent: any;
  currentTherapists?: any;
};

type Request = {
  employee: any;
  actions: any;
  id: any;
  status: any;
};

const ICON = {
  IconUser: "/static/images/icon_user_square.png",
  IconBirthday: "/static/images/icon_birthday_cake.png",
  IconChatBox: "/static/images/icon_pink_chat_box.png",
};

const COLOR = {
  primary: "var(--primary-theme-color)",
  light_pink: "#ffd8d8",
  red: "#d31919",
  green: "#14ae5c",
  dark_green: "#28922c",
};

const STATUS_OPTIONS = [
  { key: "approve", text: "เป็นสมาชิก", value: "A" },
  { key: "cancel", text: "ยกเลิกเป็นสมาชิก", value: "X" },
];

const ROWS_PER_PAGE = 15;

const lightPinkBoxStyle: React.CSSProperties = {
  backgroundColor: "#fff2f2",
  borderRadius: "4px",
  padding: "0.3rem 1rem",
  display: "inline-block",
  width: "200px",
  wordBreak: "break-word",
  whiteSpace: "normal",
};

const labelStyle: React.CSSProperties = {
  display: "inline-block",
  width: "165px",
  fontWeight: "bold",
  verticalAlign: "top",
};

const fieldContainerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  marginBottom: "1rem",
};

const CardOAMemberList: React.FC<CardOAMemberListProps> = (props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [filterName, setFilterName] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [memberFilterStatus, setMemberFilterStatus] = useState("A");
  const [filteredTherapists, setFilteredTherapists] = useState<any[]>([]);
  const [selectedRequest, setSelectedRequest] = useState<Request | null>(null);
  const [activePage, setActivePage] = useState(1);
  const [memberFilterName, setMemberFilterName] = useState("");
  const [memberFilterSubmitFrom, setMemberFilterSubmitFrom] = useState("");
  const [memberFilterSubmitTo, setMemberFilterSubmitTo] = useState("");
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [memberActivePage, setMemberActivePage] = useState(1);
  const [profileInfoOpen, setProfileInfoOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [isDeletetLoading, setDeleteLoading] = useState(false);
  const [submittedmemberFilterStatus, setSubmittedmemberFilterStatus] = useState<
    string | undefined
  >();
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [isCancelLoading, setCancelLoading] = useState(false);
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);
  const [activateReason, setActivateReason] = useState("");
  const [isActivateLoading, setActivateLoading] = useState(false);

  const handleTabChange = (e: any, { activeIndex }: any) => {
    setFilterName("");
    setFilterStartDate("");
    setFilterEndDate("");

    setMemberFilterName("");
    setMemberFilterSubmitFrom("");
    setMemberFilterSubmitTo("");
    setMemberFilterStatus("A");
    setSubmittedmemberFilterStatus("");
    setProfileInfoOpen(false);

    props.onEvent({
      message: "HandleGetTherapistList",
    });
    setActiveTabIndex(activeIndex);
  };

  const getDisplayName = (employee: any) =>
    employee?.full_name?.trim() ||
    `${employee?.first_name ?? ""} ${employee?.last_name ?? ""}`.trim();

  const pendingTherapists = (props.currentTherapists || [])
    .filter((t: any) => t.status === "S")
    .filter((t: any) => {
      if (!filterName) return true;
      return getDisplayName(t.employee).toLowerCase().includes(filterName.toLowerCase());
    });

  const totalPages = Math.max(1, Math.ceil(pendingTherapists.length / ROWS_PER_PAGE));

  const OAMember = (props.currentTherapists || [])
    .filter((t: any) => t.status === "X" || t.status === "A")
    .filter((t: any) => {
      if (!filterName) return true;
      return getDisplayName(t.employee).toLowerCase().includes(filterName.toLowerCase());
    })
    .filter((t: any) =>
      submittedmemberFilterStatus ? t.status === submittedmemberFilterStatus : true
    );

  const totalMemberPages = Math.max(1, Math.ceil(OAMember.length / ROWS_PER_PAGE));
  const currentMemberData = OAMember.slice(
    (memberActivePage - 1) * ROWS_PER_PAGE,
    memberActivePage * ROWS_PER_PAGE
  );

  const handlePageChange = (_e: any, { activePage }: any) => {
    setActivePage(activePage);
  };

  const handleMemberPageChange = (e: any, { activePage }: any) => {
    setMemberActivePage(activePage);
  };

  const currentPendingData = filteredTherapists.slice(
    (activePage - 1) * ROWS_PER_PAGE,
    activePage * ROWS_PER_PAGE
  );

  const emptyRowsCount = ROWS_PER_PAGE - currentPendingData.length;
  const emptyRows = Array.from({ length: emptyRowsCount > 0 ? emptyRowsCount : 0 });

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return "-";
    return moment(dateStr).format("DD/MM/YYYY");
  };

  const handleSearchClick = () => {
    const formatDate = (dateStr: string, isEnd = false) => {
      if (!dateStr) return undefined;
      const date = new Date(dateStr);
      if (isEnd) date.setHours(23, 59, 59, 999);
      return date.toISOString();
    };

    const startISO = formatDate(filterStartDate);
    const endISO = formatDate(filterEndDate, true);

    props.onEvent({
      message: "HandleSearchTherapistList",
      params: {
        name: filterName || undefined,
        status: memberFilterStatus || undefined,
        startDate: startISO,
        endDate: endISO,
      },
    });
  };

  const handleMemberSearchClick = () => {
    setSubmittedmemberFilterStatus(memberFilterStatus || undefined);

    const formatDate = (dateStr: string, isEnd = false) => {
      if (!dateStr) return undefined;
      const date = new Date(dateStr);
      if (isEnd) date.setHours(23, 59, 59, 999);
      return date.toISOString();
    };

    const startISO = formatDate(memberFilterSubmitFrom);
    const endISO = formatDate(memberFilterSubmitTo, true);

    props.onEvent({
      message: "HandleSearchTherapistList",
      params: {
        name: memberFilterName || undefined,
        status: memberFilterStatus || undefined,
        startDate: startISO,
        endDate: endISO,
      },
    });
  };

  const ReasonModal = ({
    open,
    onClose,
    title,
    reason,
    setReason,
    loading,
    onConfirm,
  }: {
    open: boolean;
    onClose: () => void;
    title: string | ReactNode;
    reason: string;
    setReason: (val: string) => void;
    loading: boolean;
    onConfirm: () => void;
  }) => {
    return (
      <Modal open={open} onClose={onClose} size="small">
        <Modal.Content>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{title}</span>
            <span style={{ color: "#db2828", marginLeft: "4px" }}>*</span>
          </div>

          <TextArea
            placeholder="โปรดระบุเหตุผล..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            style={{
              width: "100%",
              minHeight: "100px",
              marginTop: "10px",
              padding: "5px",
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <Button
              style={{ backgroundColor: COLOR.primary, color: "white" }}
              loading={loading}
              disabled={loading || reason.trim() === ""}
              onClick={onConfirm}
            >
              ยืนยัน
            </Button>
            <Button
              onClick={() => {
                setReason("");
                onClose();
              }}
            >
              ปิดหน้าต่าง
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  const renderPendingTable = (data: any[], setSelectedRequest: any, emptyRows: any[]) => (
    <>
      <Table celled structured selectable style={{ textAlign: "center" }}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ชื่อผู้ส่งคำขอ</Table.HeaderCell>
            <Table.HeaderCell>วันที่ส่งคำขอ</Table.HeaderCell>
            <Table.HeaderCell>รายละเอียดโปรไฟล์</Table.HeaderCell>
            <Table.HeaderCell>ยืนยันคำขอ</Table.HeaderCell>
            <Table.HeaderCell>ลบคำขอ</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map((therapist: any) => (
            <Table.Row key={therapist.id}>
              <Table.Cell style={{ textAlign: "left" }}>
                {therapist.employee.full_name?.trim()
                  ? therapist.employee.full_name
                  : `${therapist.employee.first_name ?? ""} ${
                      therapist.employee.last_name ?? ""
                    }`.trim()}
              </Table.Cell>
              <Table.Cell>
                {moment(therapist.last_submit_at).format("DD/MM/YYYY\u00A0\u00A0\u00A0HH.mm น.")}
              </Table.Cell>
              <Table.Cell>
                <Button
                  size="small"
                  style={{
                    border: `1px solid ${COLOR.primary}`,
                    color: COLOR.primary,
                    backgroundColor: "white",
                  }}
                  onClick={() => {
                    setSelectedRequest(therapist);
                    setProfileInfoOpen(true);
                  }}
                >
                  ข้อมูลโปรไฟล์
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button
                  size="small"
                  style={{
                    color: "#137e45",
                    backgroundColor: "#c4eac5",
                  }}
                  onClick={() => {
                    setSelectedRequest(therapist);
                    setIsConfirmModalOpen(true);
                  }}
                >
                  ยืนยัน
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button
                  size="small"
                  style={{
                    color: COLOR.red,
                    backgroundColor: COLOR.light_pink,
                  }}
                  onClick={() => {
                    setSelectedRequest(therapist);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  ลบ
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
          {emptyRows.map((_, idx) => (
            <Table.Row key={`empty-${idx}`} style={{ height: "50px" }}>
              <Table.Cell>&nbsp;</Table.Cell>
              <Table.Cell>&nbsp;</Table.Cell>
              <Table.Cell>&nbsp;</Table.Cell>
              <Table.Cell>&nbsp;</Table.Cell>
              <Table.Cell>&nbsp;</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      <Modal
        open={profileInfoOpen}
        onClose={() => setProfileInfoOpen(false)}
        size="large"
        style={{ padding: "20px" }}
      >
        <Modal.Content>
          <Icon
            name="close"
            style={{ position: "absolute", top: "20px", right: "10px", cursor: "pointer" }}
            onClick={() => setProfileInfoOpen(false)}
            size="large"
          />
          <Grid>
            <Grid.Column width={4} textAlign="center">
              <img
                src={
                  selectedRequest?.employee?.extra?.image
                    ? selectedRequest?.employee.extra.image
                    : ICON.IconUser
                }
                style={{
                  width: "200px",
                  height: "200px",
                  objectFit: "cover",
                }}
              />
            </Grid.Column>

            <Grid.Column width={12}>
              <Grid columns={2}>
                <Grid.Column>
                  <h3 style={{ marginBottom: "2rem", color: COLOR.primary }}>
                    <strong>ข้อมูลโปรไฟล์</strong>
                  </h3>

                  <div style={fieldContainerStyle}>
                    <span style={labelStyle}>ชื่อ</span>
                    <div style={lightPinkBoxStyle}>
                      {selectedRequest?.employee?.first_name || "-"}
                    </div>
                  </div>

                  <div style={fieldContainerStyle}>
                    <span style={labelStyle}>เลขประจำตัวประชาชน/เลขหนังสือเดินทาง</span>
                    <div style={lightPinkBoxStyle}>
                      {selectedRequest?.employee?.citizen_no
                        ? selectedRequest?.employee?.citizen_no
                        : selectedRequest?.employee?.passport_no || "-"}
                    </div>
                  </div>

                  <div style={fieldContainerStyle}>
                    <span style={labelStyle}>Email</span>
                    <div style={lightPinkBoxStyle}>{selectedRequest?.employee?.email || "-"}</div>
                  </div>
                </Grid.Column>

                <Grid.Column>
                  <div style={{ height: "22px", marginBottom: "2rem" }}></div>
                  <div style={fieldContainerStyle}>
                    <span style={{ ...labelStyle, width: "120px" }}>นามสกุล</span>
                    <div style={lightPinkBoxStyle}>
                      {selectedRequest?.employee?.last_name || "-"}
                    </div>
                  </div>

                  <div style={{ ...fieldContainerStyle, marginTop: "1.5rem" }}>
                    <span style={{ ...labelStyle, width: "120px" }}>วัน/เดือน/ปีเกิด</span>
                    <div style={lightPinkBoxStyle}>
                      {formatDate(selectedRequest?.employee?.birth_date) || "-"}
                    </div>
                  </div>

                  <div style={{ ...fieldContainerStyle, marginTop: "1.5rem" }}>
                    <span style={{ ...labelStyle, width: "120px" }}>เบอร์โทร</span>
                    <div style={lightPinkBoxStyle}>
                      {selectedRequest?.employee?.phone_no || "-"}
                    </div>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>
      <Modal
        open={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        size="mini"
        style={{ justifyContent: "center", alignItems: "center", textAlign: "center" }}
      >
        <Modal.Content>
          <h3 style={{ color: COLOR.primary }}>ยืนยันการอนุมัติ</h3>
          <div style={{ fontWeight: "bold", fontSize: "16px" }}>
            {selectedRequest?.employee?.full_name?.trim() ||
              `${selectedRequest?.employee?.first_name ?? ""} ${
                selectedRequest?.employee?.last_name ?? ""
              }`.trim()}
          </div>
          เข้าร่วม Official Account
          <div
            style={{
              display: "flex",
              marginTop: "20px",
              gap: "10px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button onClick={() => setIsConfirmModalOpen(false)}>ยกเลิก</Button>
            <Button
              style={{ backgroundColor: COLOR.primary, color: "white" }}
              loading={props.buttonLoadCheck.approveTherapist === "LOADING"}
              onClick={async () => {
                props.onEvent({
                  message: "HandleApproveTherapist",
                  params: { therapistId: selectedRequest?.id },
                });
                setSelectedRequest({
                  ...selectedRequest,
                  status: "A",
                  actions: [
                    ...(selectedRequest?.actions || []),
                    { action: "APPROVE", datetime: new Date() },
                  ],
                });
                setIsConfirmModalOpen(false);
              }}
            >
              ยืนยัน
            </Button>
          </div>
        </Modal.Content>
      </Modal>
      <ReasonModal
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title={
          <>
            ระบุเหตุผลในการ <strong>ลบคำขอเข้าร่วม OA</strong>
          </>
        }
        reason={deleteReason}
        setReason={setDeleteReason}
        loading={isDeletetLoading}
        onConfirm={async () => {
          if (deleteReason.trim() === "") return;
          setDeleteLoading(true);

          // await props.onEvent(...)

          setDeleteLoading(false);
          // setSelectedRequest({
          //   ...selectedRequest,
          //   status: "X",
          //   actions: [
          //     ...(selectedRequest?.actions || []),
          //     {
          //       action: "REJECT",
          //       comment: suspendedReason.trim(),
          //       datetime: new Date(),
          //     },
          //   ],
          // });
          setDeleteReason("");
          setIsDeleteModalOpen(false);
        }}
      />
    </>
  );

  const renderMemberTable = (data: any[], setSelectedRequest: any, emptyRowsCount: number) => (
    <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
      <div
        style={{
          width: "70%",
          flexShrink: 0,
          overflowX: "auto",
        }}
      >
        <Table celled structured selectable style={{ textAlign: "center" }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>รายชื่อผู้ได้รับการอนุมัติ</Table.HeaderCell>
              <Table.HeaderCell>วันที่ส่งคำขอ</Table.HeaderCell>
              <Table.HeaderCell>สถานะปัจจุบัน</Table.HeaderCell>
              <Table.HeaderCell>รายละเอียดโปรไฟล์</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.map((therapist: any) => {
              return (
                <Table.Row key={therapist.id}>
                  <Table.Cell style={{ textAlign: "left" }}>
                    {therapist.employee.full_name?.trim()
                      ? therapist.employee.full_name
                      : `${therapist.employee.first_name ?? ""} ${
                          therapist.employee.last_name ?? ""
                        }`.trim()}
                  </Table.Cell>
                  <Table.Cell>
                    {moment(therapist.last_submit_at).format(
                      "DD/MM/YYYY\u00A0\u00A0\u00A0HH.mm น."
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {therapist?.status === "A" ? "เป็นสมาชิก" : "ยกเลิกเป็นสมาชิก"}
                  </Table.Cell>
                  <Table.Cell>
                    <Button
                      size="small"
                      style={{
                        border: `1px solid ${COLOR.primary}`,
                        color: COLOR.primary,
                        backgroundColor: "white",
                      }}
                      onClick={() => {
                        setSelectedRequest(therapist);
                        setProfileInfoOpen(true);
                      }}
                    >
                      ข้อมูลโปรไฟล์
                    </Button>
                  </Table.Cell>
                </Table.Row>
              );
            })}

            {Array.from({ length: emptyRowsCount }).map((_, idx) => (
              <Table.Row key={`empty-member-${idx}`} style={{ height: "50px" }}>
                <Table.Cell>&nbsp;</Table.Cell>
                <Table.Cell>&nbsp;</Table.Cell>
                <Table.Cell>&nbsp;</Table.Cell>
                <Table.Cell>&nbsp;</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
          <Pagination
            activePage={memberActivePage}
            totalPages={totalMemberPages}
            onPageChange={handleMemberPageChange}
          />
        </div>
      </div>

      {profileInfoOpen && selectedRequest && (
        <div
          style={{
            flex: 1,
            marginLeft: "20px",
            backgroundColor: "white",
            border: `2px solid ${COLOR.light_pink}`,
            borderRadius: "8px",
            padding: "20px",
            paddingTop: 0,
            paddingLeft: 0,
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              position: "sticky",
              top: 0,
              left: 0,
              right: 0,
              backgroundColor: COLOR.primary,
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
              padding: "0.5rem 0",
              fontSize: "16px",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
              margin: "-20px -20px 20px -20px",
              zIndex: 2,
            }}
          >
            ข้อมูลโปรไฟล์
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
              marginLeft: "20px",
              marginTop: "50px",
            }}
          >
            <img
              src={
                selectedRequest?.employee?.extra?.image
                  ? selectedRequest?.employee.extra.image
                  : ICON.IconUser
              }
              alt="profile"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                marginRight: "20px",
              }}
            />
            <div>
              <div style={{ marginBottom: "10px" }}>
                <div
                  style={{
                    fontSize: "10px",
                    backgroundColor: selectedRequest?.status === "A" ? "#c4eac5" : "#ffcaca",
                    color: selectedRequest?.status === "A" ? COLOR.dark_green : COLOR.red,
                    borderRadius: "10px",
                    width: selectedRequest?.status === "A" ? "75px" : "100px",
                    marginBottom: "2px",
                  }}
                >
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor:
                        selectedRequest?.status === "A" ? COLOR.dark_green : COLOR.red,
                      display: "inline-block",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  />
                  {selectedRequest?.status === "A" ? "เป็นสมาชิก" : "ยกเลิกเป็นสมาชิก"}
                </div>
                <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {selectedRequest?.employee?.first_name} {selectedRequest?.employee?.last_name}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "10px",
                  }}
                >
                  <img
                    src={ICON.IconBirthday}
                    alt="birthday"
                    style={{
                      width: "10px",
                      height: "10px",
                      marginRight: "2px",
                      marginTop: "-2px",
                    }}
                  />
                  <span>{formatDate(selectedRequest?.employee?.birth_date) || "-"}</span>
                </div>
              </div>

              <Button
                disabled={selectedRequest?.status !== "A"}
                style={{
                  border:
                    selectedRequest?.status === "A"
                      ? `1px solid ${COLOR.primary}`
                      : `1px solid #bfbfbf`,
                  color: selectedRequest?.status === "A" ? COLOR.primary : "#bfbfbf",
                  backgroundColor: "white",
                  fontSize: "10px",
                  padding: "0.3rem 0.8rem",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px",
                  cursor: selectedRequest?.status === "A" ? "pointer" : "not-allowed",
                }}
              >
                <img
                  src={ICON.IconChatBox}
                  alt="chat box"
                  style={{
                    width: "10px",
                    height: "10px",
                    marginRight: "2px",
                    marginTop: "2px",
                    filter: selectedRequest?.status === "A" ? "none" : "grayscale(100%)",
                  }}
                />
                เริ่มแชท
              </Button>
            </div>
          </div>

          <div style={{ display: "flex", gap: "1rem", marginLeft: "20px" }}>
            <div style={{ flex: 1 }}>
              <div style={fieldContainerStyle}>
                <span style={labelStyle}>เลขประจำตัวประชาชน/เลขหนังสือเดินทาง</span>
                <div style={{ ...lightPinkBoxStyle, width: "180px" }}>
                  {selectedRequest?.employee?.citizen_no
                    ? selectedRequest?.employee?.citizen_no
                    : selectedRequest?.employee?.passport_no || "-"}
                </div>
              </div>
              <div style={fieldContainerStyle}>
                <span style={labelStyle}>Email</span>
                <div style={{ ...lightPinkBoxStyle, width: "180px" }}>
                  {selectedRequest?.employee?.email || "-"}
                </div>
              </div>
              <div style={fieldContainerStyle}>
                <span style={labelStyle}>เบอร์โทร</span>
                <div style={{ ...lightPinkBoxStyle, width: "180px" }}>
                  {selectedRequest?.employee?.phone_no || "-"}
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={() => {
                selectedRequest?.status === "A"
                  ? setIsCancelModalOpen(true)
                  : setIsActivateModalOpen(true);
              }}
              style={{
                border:
                  selectedRequest?.status === "A"
                    ? `1px solid ${COLOR.red}`
                    : `1px solid ${COLOR.dark_green}`,
                color: selectedRequest?.status === "A" ? COLOR.red : COLOR.dark_green,
                backgroundColor: "white",
                width: "fit-content",
                fontSize: "0.8rem",
              }}
            >
              {selectedRequest?.status === "A" ? "ยกเลิกเป็นสมาชิก" : "เปิดใช้งานอีกครั้ง"}
            </Button>
          </div>
        </div>
      )}
      <ReasonModal
        open={isCancelModalOpen}
        onClose={() => setIsCancelModalOpen(false)}
        title={
          <>
            ระบุเหตุผลในการ <strong>ยกเลิกการเป็นสมาชิก</strong>
          </>
        }
        reason={cancelReason}
        setReason={setCancelReason}
        loading={isCancelLoading}
        onConfirm={async () => {
          if (cancelReason.trim() === "") return;
          setCancelLoading(true);

          // await props.onEvent(...)

          setCancelLoading(false);
          // setSelectedRequest({
          //   ...selectedRequest,
          //   status: "X",
          //   actions: [
          //     ...(selectedRequest?.actions || []),
          //     {
          //       action: "REJECT",
          //       comment: suspendedReason.trim(),
          //       datetime: new Date(),
          //     },
          //   ],
          // });
          setCancelReason("");
          setIsCancelModalOpen(false);
        }}
      />
      <ReasonModal
        open={isActivateModalOpen}
        onClose={() => setIsActivateModalOpen(false)}
        title={
          <>
            ระบุเหตุผลในการ <strong>เปิดใช้งานสมาชิกอีกครั้ง</strong>
          </>
        }
        reason={activateReason}
        setReason={setActivateReason}
        loading={isActivateLoading}
        onConfirm={async () => {
          if (activateReason.trim() === "") return;
          setActivateLoading(true);

          // await props.onEvent(...)

          setActivateLoading(false);
          // setSelectedRequest({
          //   ...selectedRequest,
          //   status: "X",
          //   actions: [
          //     ...(selectedRequest?.actions || []),
          //     {
          //       action: "REJECT",
          //       comment: suspendedReason.trim(),
          //       datetime: new Date(),
          //     },
          //   ],
          // });
          setActivateReason("");
          setIsActivateModalOpen(false);
        }}
      />
    </div>
  );

  const FilterDate = ({
    value,
    onChange,
    placeholder = "dd/mm/yyyy",
  }: {
    value: string;
    onChange: (val: string) => void;
    placeholder?: string;
  }) => {
    const [localValue, setLocalValue] = React.useState(
      value ? moment(value).add(543, "years").format("DD/MM/YYYY") : ""
    );

    React.useEffect(() => {
      setLocalValue(value ? moment(value).add(543, "years").format("DD/MM/YYYY") : "");
    }, [value]);

    return (
      <DateTextBox
        placeholder={placeholder}
        value={localValue}
        onChange={(val) => {
          setLocalValue(val);

          const isFullDate = /^\d{2}\/\d{2}\/\d{4}$/.test(val);
          if (!isFullDate) return;

          const date = parseBeOrAdDate(val);
          if (date && date.isValid()) {
            onChange(date.format("YYYY-MM-DD"));
          }
        }}
      />
    );
  };

  useEffect(() => {
    props.onEvent({
      message: "HandleGetTherapistList",
    });
  }, []);

  useEffect(() => {
    const initialData = (props.currentTherapists || []).filter(
      (t: any) => t.status === "S" || t.status === "R"
    );
    setFilteredTherapists(initialData);
  }, [props.currentTherapists]);

  useEffect(() => {
    props.onEvent({
      message: "HandleGetTherapistList",
    });
  }, [props.currentTherapists?.status]);

  return (
    <div className="card-oa-membership" style={{ padding: "15px 0" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 20,
          padding: "0 15px",
        }}
      >
        <Header style={{ color: "rgb(79,79,79)", margin: 0 }} as="h2">
          รายชื่อสมาชิก Official Account
        </Header>
      </div>

      <Tab
        activeIndex={activeTabIndex}
        menu={{ pointing: true, secondary: true }}
        panes={[
          {
            menuItem: {
              key: "pending",
              content: (
                <div>
                  <span>รอการอนุมัติ</span>
                  <div className="badge">{currentPendingData.length || 0}</div>
                </div>
              ),
            },
            render: () => (
              <Tab.Pane>
                <div
                  style={{ height: "calc(100vh - 250px)", overflowY: "auto", paddingRight: "8px" }}
                >
                  <div
                    style={{
                      marginBottom: "1rem",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <span style={{ marginRight: "1rem" }}>ชื่อ/นามสกุล</span>
                      <Input
                        placeholder="ระบุคำค้นหา"
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                        style={{ minWidth: "300px" }}
                      />
                    </div>
                    <div>
                      <span style={{ marginRight: "1rem" }}>วันที่</span>
                      <FilterDate value={filterStartDate} onChange={setFilterStartDate} />
                      <span style={{ marginRight: "1rem", marginLeft: "1rem" }}>ถึง</span>
                      <FilterDate value={filterEndDate} onChange={setFilterEndDate} />
                    </div>
                    <Button
                      style={{ color: "white", backgroundColor: COLOR.primary }}
                      loading={props.buttonLoadCheck?.searchTherapists === "LOADING"}
                      onClick={handleSearchClick}
                    >
                      ค้นหา
                    </Button>
                  </div>
                  <div style={{ fontWeight: "normal" }}>
                    {renderPendingTable(currentPendingData, setSelectedRequest, emptyRows)}
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <Pagination
                      activePage={activePage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </Tab.Pane>
            ),
          },

          {
            menuItem: {
              key: "member list",
              content: (
                <div>
                  <span>รายชื่อสมาชิกทั้งหมด</span>
                </div>
              ),
            },
            render: () => (
              <Tab.Pane>
                <div
                  style={{ height: "calc(100vh - 250px)", overflowY: "auto", paddingRight: "8px" }}
                >
                  <div
                    style={{
                      marginBottom: "1rem",
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: "1rem",
                    }}
                  >
                    <div>
                      <span style={{ marginRight: "0.5rem" }}>ชื่อ/นามสกุล</span>
                      <Input
                        placeholder="ระบุคำค้นหา"
                        value={memberFilterName}
                        onChange={(e) => setMemberFilterName(e.target.value)}
                        style={{ minWidth: "200px" }}
                      />
                    </div>
                    <div>
                      <span style={{ marginRight: "0.5rem" }}>วันที่</span>
                      <FilterDate
                        value={memberFilterSubmitFrom}
                        onChange={setMemberFilterSubmitFrom}
                      />
                      <span style={{ margin: "0 0.5rem" }}>ถึง</span>
                      <FilterDate value={memberFilterSubmitTo} onChange={setMemberFilterSubmitTo} />
                    </div>
                    <div>
                      <span style={{ marginRight: "1rem" }}>สถานะปัจจุบัน</span>
                      <Dropdown
                        search
                        selection
                        options={STATUS_OPTIONS}
                        value={memberFilterStatus}
                        onChange={(e, { value }: any) => setMemberFilterStatus(value)}
                      />
                    </div>
                    <Button
                      style={{ color: "white", backgroundColor: COLOR.primary }}
                      loading={props.buttonLoadCheck?.searchTherapists === "LOADING"}
                      onClick={handleMemberSearchClick}
                    >
                      ค้นหา
                    </Button>
                  </div>
                  {renderMemberTable(currentMemberData, setSelectedRequest, 15)}
                </div>
              </Tab.Pane>
            ),
          },
        ]}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

export default CardOAMemberList;
